<template>
  <div
    v-if="user"
    class="col-md-2 hidden-xs hidden-sm">
    <div class="theme-account-sidebar">
      <div class="theme-account-avatar">
        <p class="theme-account-avatar-name">Bem vindo,</p>
        <p>{{ user.first_name }}</p>
      </div>
      <nav class="theme-account-nav">
        <ul class="theme-account-nav-list">
          <li>
            <a href="/agent/order/list/" target="_blank">
              <i class="fa fa-history"></i>Pedidos
            </a>
          </li>
          <li>
            <router-link :to="{ name:'dashboard-company' }">
              <i class="fa fa-building"></i>Empresas
            </router-link>
          </li>
<!--          <li>-->
<!--            <router-link :to="{ name:'dashboard-providers' }">-->
<!--              <i class="fa fa-key"></i>Credenciais-->
<!--            </router-link>-->
<!--          </li>-->
          <li>
            <a href="/agent/traveler/list/">
              <i class="fa fa-user-circle-o"></i>Usuarios
            </a>
          </li>
          <li v-if="user.isAdmin">
            <a href="/agent/pricing/">
              <i class="fa fa-money"></i>Pricing
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('auth', ['user'])
  }
};
</script>

<style lang="scss" scoped>
@import '@/scss/components/template/ScopedMenu';
</style>

